var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.className,style:(this.cssForStyle)},[_vm._t("default"),(_vm.type === 2)?_vm._t("accessory",function(){return [_c('div',{staticClass:"owal-label__right-accessory",on:{"click":_vm.accessoryCallback}},[_vm._v(" x ")])]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }